/**
 * Colunas complementares — Peças trocadas (Chamados técnicos em parque locado).
 */

import { Hash, Package, Tag, BarChart3, DollarSign, Gauge } from 'lucide-react';

export const PECAS_TROCADAS_SUBGROUP_ID = 'pecas-trocadas';

export const PECAS_AUTO_ORDER_TOOLTIP =
  'Se auto organiza na tabela de peças trocadas, abaixo do dado principal, não sendo necessário ordenar.';

/** Coluna virtual — OS da troca (TSV/painel Orya; não aparece no seletor de colunas). */
export const PECAS_OS_COLUMN_ID = 'pecaOs';

export const PECAS_COLUMN_IDS = [
  'pecaCod',
  'pecaNome',
  'pecaVidaUtil',
  'pecaReferencia',
  'pecaQtde',
  'pecaMarca',
  'pecaCustoUnitario',
  'pecaCustoTotal',
];

/** Totais na linha principal do equipamento. */
export const PECAS_MAIN_ROW_COLUMN_IDS = ['pecaQtde', 'pecaCustoTotal'];

/** Presença de alguma destas colunas gera linhas de detalhe abaixo da linha principal. */
export const PECAS_DETAIL_TRIGGER_COLUMN_IDS = [
  'pecaCod',
  'pecaReferencia',
  'pecaNome',
  'pecaVidaUtil',
  'pecaMarca',
  'pecaCustoUnitario',
];

/** Ordem dos valores na sublinha (por peça), quando marcados. */
export const PECAS_DETAIL_INLINE_FIELD_ORDER = [
  'pecaCod',
  'pecaReferencia',
  'pecaNome',
  'pecaVidaUtil',
  'pecaMarca',
  'pecaCustoUnitario',
  'pecaQtde',
  'pecaCustoTotal',
];

/** Colunas exibidas nas linhas de detalhe (quando o detalhe está ativo). */
export const PECAS_DETAIL_ROW_COLUMN_IDS = [
  ...PECAS_DETAIL_TRIGGER_COLUMN_IDS,
  'pecaQtde',
  'pecaCustoTotal',
];

export const COLUMNS_CONFIG_PECAS = [
  { id: 'pecaCod', label: 'Cód. Peça', icon: Hash },
  { id: 'pecaNome', label: 'Peça', icon: Package },
  { id: 'pecaVidaUtil', label: 'Vida útil', icon: Gauge },
  { id: 'pecaReferencia', label: 'Referência', icon: Tag },
  { id: 'pecaQtde', label: 'Qtde', icon: BarChart3 },
  { id: 'pecaMarca', label: 'Marca', icon: Tag },
  { id: 'pecaCustoUnitario', label: 'Custo unitário', icon: DollarSign },
  { id: 'pecaCustoTotal', label: 'Custo total', icon: DollarSign },
];
